import {Component} from '@angular/core';

@Component({
    selector: 'app-register-form-payment',

    templateUrl: './register-form-payment.component.html',
    styleUrl: './register-form-payment.component.css'
})
export class RegisterFormPaymentComponent {

}
